


import {
  all,
  equals,
  values,
  ifElse,
  length as RLength,
  F,
  not,
  has,
  mapObjIndexed,
  pipe,
  pick,
  is,
  allPass
} from 'ramda';
import { contentGetter } from '@synergycms_core/content/i18n';


class ManagerLinks {
  constructor() {
    this.listLangs = ['en', 'es'];
    this.data = {};
    this.content = contentGetter();
  }

  extendLinks = (config, lang) => {
    if (config) {
      this.config = Object.assign(this.data, config);
    }

    if (lang) {
      this.lang = lang;
    }
    return this;
  };

  repo = {
    hotelInfoDesc : (config) => {
        return window.hotel_address
    },
    hotelInfo : (config)=> {
        var params = config.params;
        var hotelsInfo = config.hotelsInfo.hotels;
        if (Object.prototype.toString.apply(hotelsInfo) === '[object Array]') {
            var hotel = hotelsInfo.find(function (hotel) {
              return params.hotelCode === hotel.code;
            });
            if(!hotel){
              hotel = hotelsInfo.find(function (hotel) {
                return +params.hotel_id === +hotel.id;
              });
            }
            return (hotel && hotel.name) || "";
        }
        return '';
    },
    openReservation : (config) => {
      
      var _f = function(){}
      _f = function(){
        return typeof window.openReservasGeneric == 'function' &&  window.openReservasGeneric();
      }
      return _f;
    }
  }


  getLinks = (code, position, enableBy, newConfig, params) => {

    const linkObject = newConfig || (this.config && this.config[code]);
    const lang = this.lang || 'es';

    if ((linkObject && enableBy) || (linkObject && linkObject.enabled)) {
      
      if (position && pipe(pick(position), values, ifElse(RLength, all(equals(true)), F), not)(linkObject)) {
        return false;
      }
      if (linkObject.type === 'nested') {
        return mapObjIndexed((val, key, obj) => {
          return this.getLinks(key, null, null, val);
        }, linkObject.data);
      } else if (linkObject.type === 'translation') {
        return this.content.getHasKeyAndContent('_%' + linkObject.data + '%_');
      } else if (is(Function, linkObject.data)) {
        if (linkObject.type === 'callback') {
          return () => linkObject.data(params);
        } else {
          const result = linkObject.data(params);
          return (linkObject.data = result);
        }
      } else if(linkObject.front_type_config === 'callback' && linkObject.value && is(Function, this.repo[linkObject.value])){
        return this.repo[linkObject.value](params)
      } else if (is(Object, linkObject.data)) {
        return linkObject.data[lang] || linkObject.data['en'];
      } else if (is(Object, linkObject) && linkObject[lang]){
        return linkObject[lang].translatable_value || linkObject.translatable['en'].translatable_value;
      } else {      

        const hasData = has("data");
        return (hasData(linkObject) && linkObject.data) || linkObject.enabled;
      }
    }

     
    const hasUrlAndText = allPass([has('url'), has('text')]);
    if(linkObject && hasUrlAndText(linkObject)){
      if(linkObject.showIn && position && position.length > 0){
        if(!position.includes(linkObject.showIn)){
          return false;
        }
      }
      if( linkObject.url && linkObject.text && linkObject.url[lang]?.translatable_value && linkObject.text[lang]?.translatable_value) {          
          return {
          url: linkObject.url[lang].translatable_value,
          text: linkObject.text[lang].translatable_value,
          icon: linkObject.icon
        }; 
      }
      return false;
    }



    return false;
  };
}

let linksInstance = null;
export const contentGetterLinks = (config, lang) => {
  const baseLinks = linksInstance ? linksInstance : (linksInstance = new ManagerLinks());
  return baseLinks.extendLinks(config, lang);
}